/* global process */
import React from 'react';

class HeaderBaseLogoComponent extends React.PureComponent {
  render () {
    return (
      <div className="flex align-center">
        <img
          alt="cengage learning"
          src={`${process.env.PUBLIC_URL}/images/logo-main.png`}
          className="header-main__logo"
        />

        <span className="header-main__text">
          SALT: Statistical Analysis and Learning Tool
        </span>
      </div>
    );
  }
}

export default HeaderBaseLogoComponent;
